import { CompassIcon, SplitIcon, TrendingUpIcon, ZapIcon, FlagIcon } from 'lucide-react';

export const infoSources = [
  'Yüzme antrenmanları',
  'Bisiklet antrenmanları',
  'Koşu programları',
  'Beslenme tavsiyeleri',
  'Toparlanma önerileri',
  'Yarış günü kontrol listeleri',
];

export const selfQuestions = [
  'Yeterince antrenman yapıyor muyum?',
  'Gereğinden fazla mı çalışıyorum?',
  'Bu hafta hangi antrenmanlara odaklanmalıyım?',
  'Yüzme, bisiklet ve koşu çalışmalarımı nasıl dengelemeliyim?',
  'Ne zaman yoğunluğu artırmalıyım?',
  'Ne zaman toparlanmaya öncelik vermeliyim?',
  'Uzun antrenmanlarda beslenmemi nasıl planlamalıyım?',
  'Gerçekten ilerleme kaydedip kaydetmediğimi nasıl anlayabilirim?',
  'Yarış haftası geldiğinde ne yapacağım?',
];

export const painPoints: {
  icon: typeof CompassIcon;
  title: string;
  body: string[];
  list?: string[];
  resolve?: string;
}[] = [
  {
    icon: CompassIcon,
    title: 'Nereden başlayacağınızı bilmiyorsunuz',
    body: [
      'Uzun mesafe triatlonu aylar süren bir hazırlık gerektirir.',
      'Net bir yapı olmadan, farklı antrenmanlar ve bilgiler arasında geçiş yapmak; bunların birbirini nasıl tamamladığını anlamayı zorlaştırabilir.',
    ],
    resolve: 'UZUN MESAFE TRİATLON SİSTEMİ™, hazırlık sürecinizi altı aşamada organize etmenize yardımcı olur.',
  },
  {
    icon: SplitIcon,
    title: 'Üç disiplininiz birbirinden kopuk hissediliyor',
    body: [
      'Yüzme. Bisiklet. Koşu. Üç disiplin, tek bir yarış.',
      'Hazırlığınızın bu üç alanı tamamen ayrı faaliyetler olarak değil, birbiriyle ilişkili bir bütün olarak ele alması gerekir.',
    ],
  },
  {
    icon: TrendingUpIcon,
    title: 'Gerçekten ilerleyip ilerlemediğinizi bilmiyorsunuz',
    body: [
      'Daha fazla çalışmak, her zaman daha iyi çalışmak anlamına gelmez.',
      'Antrenman düzeninizi, yükünüzü ve gelişiminizi takip edebileceğiniz yapılandırılmış bir yöntem olmadan, hangi yönde ilerlediğinizi anlamak zorlaşabilir.',
    ],
  },
  {
    icon: ZapIcon,
    title: 'Beslenme ve sıvı alımını nasıl yöneteceğinizden emin değilsiniz',
    body: [
      'Uzun mesafe yarışları, yüksek dayanıklılık gerektirir.',
      'Antrenman, denklemin yalnızca bir parçasıdır. Mesafe ve süre arttıkça beslenme, sıvı alımı ve enerji yönetiminin önemi de artar.',
    ],
  },
  {
    icon: FlagIcon,
    title: 'Yarış günü konusunda endişelisiniz',
    body: ['Aylarca antrenman yapmış olsanız bile yarış haftası geldiğinde şu sorularla karşılaşabilirsiniz:'],
    list: [
      'Yanıma neler almalıyım?',
      'Yarıştan önceki gece nasıl hazırlanmalıyım?',
      'Yarış sabahını nasıl organize etmeliyim?',
      'Geçiş alanlarını nasıl planlamalıyım?',
      'Yarışın farklı bölümlerini nasıl yönetmeliyim?',
    ],
    resolve: 'İyi bir yarış hazırlığı, başlangıç çizgisinde değil; çok daha önce başlar.',
  },
];
